module.exports = __webpack_public_path__ + "static/media/approved.32ae9f85.svg";